<div horizontalAlign="center">
  <div [style.width.px]="107" [style.height.px]="80" [style.text-align]="'center'">
    <img [src]="data.imagePreviewUrl" [style.max-width.px]="80" [style.max-height.px]="80">
  </div>
  <label id="lbl_ImageFileName">{{ this.imageFileName }}</label>
</div>
